import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useUser } from "./Login/UserContext";
import { readDreamDraft, saveDreamDraft } from "../utils/dreamDraft";

const Page = styled.main`
  width: min(620px, 100%);
  margin: 0 auto;
  padding: 32px 20px 48px;
  box-sizing: border-box;
  color: #282c34;
  h1 { font-size: clamp(1.5rem, 5vw, 2rem); }
  p { line-height: 1.8; }
  label { display: block; font-weight: 700; margin-bottom: 8px; }
  input { width: 100%; padding: 14px; border: 1px solid #888; border-radius: 10px; box-sizing: border-box; }
  button { width: 100%; padding: 14px; margin-top: 16px; border: 0; border-radius: 10px; background: #43358b; color: white; font-weight: 700; }
  a { display: inline-block; margin: 12px 0; }
  :focus-visible { outline: 3px solid #e99100; outline-offset: 3px; }
`;
const Example = styled.aside`
  margin: 24px 0;
  padding: 20px;
  border-radius: 16px;
  background: #f2effb;
  h2 { font-size: 1.1rem; }
`;

export default function StartDream() {
  const [title, setTitle] = useState(readDreamDraft);
  const [storageError, setStorageError] = useState(false);
  const [titleError, setTitleError] = useState(false);
  const { isLoggedIn } = useUser();
  const navigate = useNavigate();
  const continueTo = (path) => {
    if (!title.trim()) { setTitleError(true); return; }
    if (!saveDreamDraft(title.trim())) {
      setStorageError(true);
      return;
    }
    navigate(path, { state: { returnTo: "/Register" } });
  };

  return (
    <Page>
      <h1>まだ誰にも言っていない夢は？</h1>
      <p>大きすぎる夢も、ちょっと笑える夢も歓迎。まずは一行から。<br />ここで書いた内容は、まだ公開されません。</p>
      <form onSubmit={(event) => { event.preventDefault(); continueTo(isLoggedIn ? "/Register" : "/MemberRegisterView"); }}>
        <label htmlFor="dream-title">あなたの夢</label>
        <input id="dream-title" value={title} onChange={(event) => { setTitle(event.target.value); setTitleError(false); }} required maxLength={100} placeholder="例：自分の小説をアニメにしたい" />
        {titleError && <p role="alert">夢を一行で書いてみてください。</p>}
        <Example>
          <h2>投稿すると、こんなふうに始まります</h2>
          <p><strong>体験イメージ：自分の小説をアニメにしたい</strong></p>
          <p>AIの一歩の提案：「まず作品の紹介文を100字書いてみよう。」</p>
          <p>紹介文が書けたら、進捗として報告。人からの応援やコメントも受け取れます。</p>
          <small>これは説明用の例です。AIの反応は夢ごとに異なり、人からの反応は参加状況によります。</small>
        </Example>
        <p>投稿後は無謀度カードを共有できます。AIコメントは自分の掲示板でOFFにできます。</p>
        <button type="submit">{isLoggedIn ? "この夢の続きを書く" : "夢を引き継いで会員登録へ"}</button>
        {storageError && <p role="alert">下書きを保存できませんでした。ブラウザのストレージを有効にして、もう一度お試しください。</p>}
      </form>
      {!isLoggedIn && <Link to="/Login" state={{ returnTo: "/Register" }} onClick={(event) => {
        if (!saveDreamDraft(title.trim())) { event.preventDefault(); setStorageError(true); }
      }}>登録済みの方はログインして続きを書く</Link>}
      <p><Link to="/Ranking">まずは、ほかの人の夢を見てみる</Link></p>
    </Page>
  );
}
